import { Component } from '@angular/core';

@Component({
  selector: 'mvta-layout',
  template: '<router-outlet><spinner></spinner></router-outlet>'
})
export class CleanLayoutComponent {}
